import React from "react";
import FieldInfoPopover from "./FieldInfoPopover";

export default function TextareaField({
  field,
  required,
  error,
  errorType,
  onChange,
  placeholder,
}) {
  const remaining = field.maxLength ? field.maxLength - (field.value || "").length : null;
  const showRequiredError = errorType === "required" && (field.value || "").length === 0;
  const showMaxLengthError =
    errorType === "maxLength" &&
    field.maxLength != null &&
    (field.value || "").length > field.maxLength;

  return (
    <div className="col-12">
      <div className="row">
        <div className="col-12">
          <div className={`form-group m-0 ${error ? "is-invalid" : ""}`}>
            <label htmlFor={field.id}>
              {required ? <span>*</span> : null}
              {field.title}
            </label>
            <div className={field.labelInfoPopover ? "formHelper" : undefined}>
              <div className="validation-cover">
                <textarea
                  id={field.id}
                  className={`form-control`}
                  rows="10"
                  autoComplete="off"
                  value={field.value || ""}
                  placeholder={placeholder}
                  onChange={(event) => onChange(field.id, event.target.value)}
                />
              </div>
              <FieldInfoPopover html={field.labelInfoPopover} />
            </div>
            {field.description ? <div className="mt-2">{field.description}</div> : null}
            {remaining !== null ? (
              <div className={`text-right mt-2 small ${remaining < 0 ? "text-danger" : "text-blue"} ${error ? "pr-7" : ""}`}>
                <i>Maximum characters {remaining}</i>
              </div>
            ) : null}
          </div>
        </div>
        {(showRequiredError || showMaxLengthError) ? (
          <div className="col-md-6 mb-3">
            {showRequiredError ? (
              <div className="text-danger mt-md-4">
                <i>
                  *Mandatory Fields that
                  <br />
                  must be completed
                </i>
              </div>
            ) : null}
            {showMaxLengthError ? (
              <div className="text-danger mt-md-4">
                <i>
                  *Your {field.title.toLowerCase()} must not
                  <br />
                  exceed {field.maxLength} characters
                </i>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
